import { createSelector } from '@reduxjs/toolkit';
import { selectLocation } from 'shared/selectors/location';
import { selectRegionalDistrictsModal } from './selectRegionalDistrictsModal';
import { getRegionId } from 'shared/utils/geo';

export const selectNeedRegionalDistrictsRequest = createSelector(
  [selectLocation, selectRegionalDistrictsModal],
  (currentLocation, regionalDistrictsModal) => {
    const currentRegionId = getRegionId(currentLocation);
    const { districts, regionId } = regionalDistrictsModal;

    return currentRegionId !== regionId || !districts.length;
  },
);
